import { connect } from "react-redux";
import {
  getClientStats,
  getClientSubscriptionStats,
  getClientTagStats,
  getInsightsStats,
  clearDashboardStats,
} from "../actions/Dashboard";
import Dashboard from "../components/Dashboard/index";
import {
  selectClient,
  setLoginErrorMessage,
  getClientInfo,
  getDisabledFeatures,
} from "../actions/App";

const mapStateToProps = (state) => {
  const {
    client_subscription_stats,
    client_stats,
    client_tag_stats,
    insights_stats,
  } = state.dashboard;
  const {
    roleId,
    selected_client,
    optimizeUserDetail,
    loginUserDetail,
    client_info,
    clients,
    loadingOptimizeUserDetail,
    disabledFeatures,
    loadingDisabledFeatures,
  } = state.app;
  return {
    client_subscription_stats,
    client_stats,
    client_tag_stats,
    insights_stats,
    roleId,
    selected_client,
    loginUserDetail,
    optimizeUserDetail,
    client_info,
    clients,
    loadingOptimizeUserDetail,
    disabledFeatures,
    loadingDisabledFeatures,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getClientStats: () => {
      dispatch(getClientStats());
    },
    setLoginErrorMessage: (message) => {
      dispatch(setLoginErrorMessage(message));
    },

    getClientSubscriptionStats: () => {
      dispatch(getClientSubscriptionStats());
    },

    getClientTagStats: () => {
      dispatch(getClientTagStats());
    },

    getInsightsStats: (period) => {
      dispatch(getInsightsStats(period));
    },

    selectClient: (clientId) => {
      dispatch(selectClient(clientId));
    },

    getClientInfo: (clientId) => {
      dispatch(getClientInfo(clientId));
    },

    clearDashboardStats: () => {
      dispatch(clearDashboardStats());
    },
    getDisabledFeatures: () => {
      dispatch(getDisabledFeatures());
    },
  };
};

const DashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);

export default DashboardContainer;



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js